import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { ISelectItem } from '@lla-platform/core/core-ui'
import { UntilDestroy } from '@ngneat/until-destroy'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { ShopsState } from '@lla-platform/shops/shops-data-access'
import { Store } from '@ngxs/store'
import { environment } from '@lla-platform/core/core-util'
import { TippyProps } from '../../directives/lla-tippy.directive'

@UntilDestroy()
@Component({
  selector: 'lla-shops-selector-menu',
  templateUrl: './shops-selector-menu.component.html',
  styleUrls: ['./shops-selector-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ShopsSelectorMenuComponent implements OnInit, OnChanges {
  @Input() selectedIds: string[] = []
  @Input() onlyUserShops = true
  @Output() selectedIdsChanged = new EventEmitter<string[]>()

  maxSelectableShops = environment.maxSelectableShops
  selectedShopGroups?: string[]
  form: UntypedFormGroup

  allShopsList = inject(Store).selectSnapshot<ISelectItem[]>(ShopsState.allShopsAsList)
  selectedShopsLabel = ''

  tooltipOption: Partial<TippyProps> = {
    arrow: false,
    hideOnClick: true,
    touch: 'hold',
    placement: 'bottom-start'
  }

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      locationIds: [this.selectedIds]
    })
    this.updateSelectedShopsLabel()
  }

  ngOnChanges(): void {
    this.updateSelectedShopsLabel()
  }

  getSelectedShopNames() {
    return this.allShopsList.filter((el) => this.selectedIds.includes(el.value)).map((el) => el.label)
  }

  resetSelection() {
    setTimeout(() => {
      this.form.get('locationIds')?.setValue(this.selectedIds)
    }, 200)
  }

  private updateSelectedShopsLabel(): void {
    if (this.selectedIds.length === 0) {
      this.selectedShopsLabel = ''
    } else if (this.selectedIds.length === 1) {
      this.selectedShopsLabel = this.allShopsList.find((el) => el.value === this.selectedIds[0])?.label ?? ''
    } else {
      this.selectedShopsLabel = `${this.selectedIds.length} locations selected`
    }
  }
}
